export const personalDataDictionary = [
  { key: true, value: 'Chcę podać dane właściciela' },
  {
    key: false,
    value: 'Nie chcę podawać danych',
  },
];
